import { useState, type ReactElement } from 'react'

import { CookieBanner } from '@/components/common/CookieBanner'
import { CookieSettingsDialog } from '@/components/common/CookieSettingsDialog'
import { useUiStore } from '@/stores/ui.store'

export function CookieConsent(): ReactElement {
  const setSidebarOpen = useUiStore((state) => state.setSidebarOpen)
  const [settingsOpen, setSettingsOpen] = useState(false)

  return (
    <>
      <CookieBanner
        onManage={() => {
          setSidebarOpen(false)
          setSettingsOpen(true)
        }}
      />
      <CookieSettingsDialog
        open={settingsOpen}
        onClose={() => {
          setSettingsOpen(false)
        }}
      />
    </>
  )
}
